import { render, staticRenderFns } from "./ListItemsForm.vue?vue&type=template&id=68e26ce5&"
import script from "./ListItemsForm.vue?vue&type=script&lang=js&"
export * from "./ListItemsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports